<div class="header" fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="center center">
    <img width="40px" src={{iconUrl}} alt="Icona incidència">
    <span class="title"> Park & Ride {{ station }}</span>
</div>

<div class="content">
    <div *ngIf="size > 0">
        <span class="detail-name" i18n>Capacidad:</span> {{size}}
    </div>

    <div *ngIf="occupied > 0">
        <span class="detail-name" i18n>Ocupadas:</span> {{occupied}}
    </div>
</div>

<div *ngIf="operador" class="source">
    <b i18n>Operador:</b> {{operador}}
</div>
